export const followupColumns = [
    {
        field: "dob",
        headerName: "DOB",
        width: 160,
    },
    {
        field: "timeSlot",
        headerName: "Time Slot",
        width: 120
    },
    {
        field: "gender",
        headerName: "Gender",
        width: 130,
    },
    {
        field: "reminderCall",
        headerName: "Reminder Call",
        width: 160,
    },
    {
        field: "demo",
        headerName: "Demo",
        width: 120,
    },
    {
        field: "serviceName",
        headerName: "Service Name",
        width: 160,
    },
    {
        field: "category",
        headerName: "Category",
        width: 120,
    },
    {
        field: "userName",
        headerName: "User Name",
        width: 160,
    },
    {
        field: "email",
        headerName: "User Email",
        width: 160,
    },
    {
        field: "number",
        headerName: "User Number",
        width: 160,
    },
    {
        field: "branchName",
        headerName: "Branch Name",
        width: 130,
    },
    {
        field: "branchLocation",
        headerName: "Branch Loc",
        width: 130,
    },
  ];